module.exports = __webpack_public_path__ + "img/icon-export-pdf.9fca1680.svg";